<div class="decoration"></div>

<div class="content">
  <div class="top" *ngIf="!isDevMode">
    <app-language-selector></app-language-selector>
  </div>
  <div class="center">
    <!-- Both variants ship; the theme family hides one (see .theme-asset-* in
         styles.scss). Rendering both rather than binding the src keeps the logo correct
         from the first paint, with no template read of the theme. -->
    <div class="sytex-logo">
      <img class="theme-asset-light" src="assets/sytex-logo.svg" alt="Sytex" />
      <img class="theme-asset-dark" src="assets/sytex-logo-dark.svg" alt="Sytex" />
    </div>
    <router-outlet></router-outlet>
    <div class="footer">
      <div class="right">
        <div class="phrase" i18n="@@accelerate.field.operations">
          Accelerate Field Operations
        </div>
        <div class="hashtag">
          <span class="gradient-text-full">
            <span i18n="@@hashtag.efficiency">+Efficiency</span>
            <span i18n="@@hashtag.intelligence">+Intelligence</span>
            <span i18n="@@hashtag.quality">+Quality</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
